import {
  type PimDocumentV1,
  PimDocumentV1TypeEnum,
  type PimProductV11,
} from '@redteclab/api/clients/bully'

export const productAccessorGetPackageInsert = (
  product: PimProductV11,
): PimDocumentV1 | undefined => {
  const documents = product.documents ?? []

  if (documents.length === 0) {
    return undefined
  }

  return documents.find(
    (doc) =>
      doc.type === PimDocumentV1TypeEnum.InternalBp ||
      doc.type === PimDocumentV1TypeEnum.ExternalBp,
  )
}
